import React, { useEffect } from "react";
import { useSearchParams, useLocation } from "react-router-dom";

import LatestNews from "./PressRoomTabs/LatestNews";
import EventCalendar from "./PressRoomTabs/EventCalendar";
import Publications from "./PressRoomTabs/Publications";
import Gallery from "./PressRoomTabs/Gallery";
import DaySeafarer from "./PressRoomTabs/DaySeafarer";

function PressRoomTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const section = searchParams.get("section") || "latest-news";

  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById(section);
      const queryParams = new URLSearchParams(location.search);
      if (element && queryParams.get("section") !== null) {
        const header = document.querySelector("header");
        const offset = header ? header.offsetHeight : 0;
        const top = element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 300);
  }, [location.search]);

  const handleClick = (newSection) => {
    setSearchParams({ section: newSection });
    const closeBtn = document.querySelector(".btn-cus");
    if (closeBtn) closeBtn.click();
  };

  return (
    <section className="ManagementTeam px-3 small-anchor" id="ManagementTeam">
      <div className="container max-1330 mx-auto">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-lg-3 col-md-4">
            <div className="d-md-none text-end">
              <i
                className="bi bi-list border-0 ms-auto font-32"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasResponsive"
                aria-controls="offcanvasResponsive"
              ></i>
            </div>
            <div
              className="offcanvas-md offcanvas-end"
              tabIndex="-1"
              id="offcanvasResponsive"
              aria-labelledby="offcanvasResponsiveLabel"
            >
              <div className="offcanvas-header d-md-none">
                <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">
                  Press Room
                </h5>
                <button
                  type="button"
                  className="btn-close btn-cus"
                  data-bs-dismiss="offcanvas"
                  data-bs-target="#offcanvasResponsive"
                  aria-label="Close"
                ></button>
              </div>

              <div
                className="accordion leftMenu px-3 px-md-0 pb-3 pb-md-0 overflow-auto overflow-md-visible"
                id="accordionExample"
              >
                {[
                  { label: "LATEST NEWS", key: "latest-news" },
                  // { label: "EVENTS CALENDAR", key: "events-calendar" },
                  { label: "EVENTS", key: "events-calendar" },
                  { label: "PUBLICATIONS", key: "publications" },
                  // { label: "GALLERY", key: "gallery" },
                  // { label: "DAY OF THE SEAFARER", key: "day-of-the-seafarer" },
                ].map(({ key, label }, idx) => (
                  <div className="accordion-item" key={key}>
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${section === key ? "collapsed gray-active" : "collapsed"}`}
                        
                        onClick={() => handleClick(key)}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${idx}`}
                        aria-expanded="false"
                        aria-controls={`collapse${idx}`}
                      >
                        {label}
                      </button>
                    </h2>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-9 col-md-8">
            <div id="latest-news">{section === "latest-news" && <LatestNews />}</div>
            <div id="events-calendar">{section === "events-calendar" && <EventCalendar />}</div>
            <div id="publications">{section === "publications" && <Publications />}</div>
            {/* <div id="gallery">{section === "gallery" && <Gallery />}</div> */}
            {/* <div id="day-of-the-seafarer">{section === "day-of-the-seafarer" && <DaySeafarer />}</div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PressRoomTab;
